import {AppConsts} from "../AppConsts";
import axios from "axios";
import qs from "querystring";

class AbpHttp {
  constructor() {
    axios.interceptors.response.use(
      response => {
        return this.handleResponse(response);
      },
      error => {
        return this.handleErrorResponse(error.response);
      }
    );
  }

  request(url, formData) {
    let options = {
      headers: {}
    };

    if (formData) {
      options.method = "post";
      options.data = formData;
    } else {
      options.method = "get";
    }

    this.normalizeRequestOptions(options);

    options.url = AppConsts.remoteServiceBaseUrl + url;

    return axios(options).then(response => {
      if (response) {
        return response.data;
      } else {
        return response;
      }
    });
  }

  //格式化options
  normalizeRequestOptions(options) {
    if (!options.headers) {
      options.headers = {};
    }
    let token = abp.auth.getToken();
    let role = abp.utils.getCookieValue("role");
    let localization = AppConsts.currentLanguage();

    if (token) {
      options.headers.Authorization = token;
    }
    if (role) {
      options.headers.role = role;
    }
    if (localization) {
      options.headers.localization = localization;
      options.headers["Accept-Language"] = localization;
    }
  }

  //根据不同ERROR CODE 显示错误信息
  handleErrorResponse(error) {
    const self = this;
    switch (error.status) {
      case 400:
      case 401:
        abp.auth.clearToken();
        window.location.reload();
        return Promise.reject();
        break;
      case 403:
        return self.showError("403");
        break;
      case 404:
        return self.showError("404");
        break;
      default:
        if (error.data && error.data.msg) {
          if (typeof error.data.msg == 'string') {
            return self.showError(error.data.msg);
          } else {
            return Promise.reject();
          }
        } else {
          return self.showError("未处理错误");
        }
        break;
    }
  }

  //获取Response
  handleResponse(response) {
    if (response.data) {
      if (!response.data.hasError) {
        return response;
      } else {
        return this.handleErrorResponse(response);
      }
    } else {
      return response;
    }
  }

  //显示错误信息
  showError(errorMsg) {
    return abp.notify.error(errorMsg).then(_ => {
      return Promise.reject();
    });
  }
}

export default new AbpHttp();



// WEBPACK FOOTER //
// ./src/shared/libs/ClientFramework/packages/abpVue/http/AbpHttp.js